import colors from '@constants/colors';
import styled from '@emotion/styled';

interface Props {
    width?: string | number;
    height?: string | number;
    radius?: string | number;
    backgroundColor?: string;
    left?: number;
    top?: number;
    right?: number;
    bottom?: number;
}

function SkeletonBlank({
    width = '100%', height = 20, radius = 4, backgroundColor = colors.white,
    left, top, right, bottom,
}:Props) {
    return (
        <Base width={width}
            height={height}
            radius={radius}
            backgroundColor={backgroundColor}
            left={left}
            top={top}
            right={right}
            bottom={bottom}
        />
    );
}

const Base = styled.div<{
    width: string | number;
    height: string | number;
    radius: string| number;
    backgroundColor?: string;
    left?: number;
    top?: number;
    right?: number;
    bottom?: number;
}>`
    position: absolute;
    width: ${({ width }) => (typeof width === 'string' ? width : `${width}px`)};
    height: ${({ height }) => (typeof height === 'string' ? height : `${height}px`)};
    min-width: ${({ width }) => (typeof width === 'string' ? width : `${width}px`)};
    min-height: ${({ height }) => (typeof height === 'string' ? height : `${height}px`)};
    border-radius: ${({ radius }) => (typeof radius === 'string' ? radius : `${radius}px`)};
    background-color: ${(props) => props.backgroundColor || colors.white};
    left: ${(props) => (props.left !== undefined ? `${props.left}px` : 'unset')};
    top: ${(props) => (props.top !== undefined ? `${props.top}px` : 'unset')};
    right: ${(props) => (props.right !== undefined ? `${props.right}px` : 'unset')};
    bottom: ${(props) => (props.bottom !== undefined ? `${props.bottom}px` : 'unset')};
`;

export default SkeletonBlank;
